import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="LMS">
                <h1>LMS Development Company</h1>
              </div>
              <div className=" banner_content_txt listing_flex">
                <p>
                  Acquire your easy-to-use, custom, and scalable learning
                  management solution that offers exceptional learning
                  experiences through our LMS development company.
                </p>
                <ul>
                  <li>Priority-based learning</li>
                  <li>Seamless HRMS integration</li>
                  <li>Scalable and compatible code</li>
                  <li>Improved engagement and ROI</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
